// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=parser-js|name=ChatFileAttachment|schemaHash=b86762090256d37b882afb907efd72f7843b262d

import { setDefinedValue } from '@myre/common-primitives';

export function parseChatFileAttachmentFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'fileId', _data.fileId);
  setDefinedValue(result, 'fileName', _data.fileName);
  setDefinedValue(result, 'mimeType', _data.mimeType);
  setDefinedValue(result, 'fileSize', _data.fileSize);

  return result;
}

export function parseChatFileAttachmentToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'fileId', _data.fileId);
  setDefinedValue(result, 'fileName', _data.fileName);
  setDefinedValue(result, 'mimeType', _data.mimeType);
  setDefinedValue(result, 'fileSize', _data.fileSize);

  return result;
}
